import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import {
    Box, Slide, 
    Typography
} from '@mui/material';
import {
    TypographyVariants, TypographyWeights 
} from '../../../../figmaTheme';

type Props = {
    screenDirection: 'left' | 'right',
    slide?: boolean,
    title: string,
    subtitle: string,
    illustration?: JSX.Element,
    trackingName: string
}

export const Pillar = ({
    screenDirection,
    slide = false,
    title,
    subtitle,
    illustration
}: Props): JSX.Element => {
    const useStyles = makeStyles(() => ({
        content: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center'
        },
        title: {
            fontWeight: TypographyWeights.BOLD,
            textAlign: 'center',
            marginBottom: '11px'
        },
        subtitle: {
            textAlign: 'center',
            marginBottom: '40px'
        }
    }));

    const classes = useStyles();

    return (
        <>
            {slide ? (
                <Slide
                    in={slide}
                    direction={screenDirection}
                    timeout={500}
                    mountOnEnter
                    unmountOnExit
                >
                    <Typography
                        variant={TypographyVariants.H3}
                        className={classes.title}
                    >
                        {title}
                    </Typography>
                </Slide>
            ) : (
                <Typography
                    variant={TypographyVariants.H3}
                    className={classes.title}
                >
                    {title}
                </Typography>
            )}
            <Slide
                in={true}
                direction={screenDirection}
                timeout={500}
                mountOnEnter
                unmountOnExit
            >
                <Box className={classes.content}>
                    <Typography
                        variant={TypographyVariants.H6}
                        className={classes.subtitle}
                    >
                        {subtitle}
                    </Typography>
                    {illustration}
                </Box>
            </Slide>
        </>
    );
};

export default Pillar;
